export function parseJwt<T = unknown>(token: string): T | null {
    try {
        const base64 = token.split(".")[1];
        const decoded = atob(base64.replace(/-/g, "+").replace(/_/g, "/"));
        const json = decodeURIComponent(
            decoded.split("").map(c => "%" + c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
        );
        return JSON.parse(json);
    } catch {
        return null;
    }
}

export function isJwtExpired(token: string): boolean {
    try {
        const payloadBase64 = token.split(".")[1];
        if (!payloadBase64) return true;

        const payload = JSON.parse(atob(payloadBase64));

        if (!payload.exp) return true;

        const now = Date.now() / 1000;
        return payload.exp < now;
    } catch (e) {
        console.error("Failed to decode JWT:", e);
        return true; // Treat as expired if invalid
    }
}
